(function() {
  'use strict';

  angular.module('component.announcements')
    .component('announcements', {
      templateUrl: 'app/components/announcements/list.html',
      controller: 'AnnouncementsController',
      controllerAs: 'announcementsCtrl'
    });
})();
